import React from "react";
import { IcFacebook, IcInstagram, IcWhattsApp, Lazada, Shopee, TeamWork, Tokopedia } from "../../assets/img";
import { Marketplace } from "../../components";
import MARKETPLACE from "../../config/Marketplace";
import SOSMED from '../../config/Sosmed';

const About = () => {
    return (
      <div id='about'>
        <h1 data-aos='fade-right'>Tentang Kami</h1>
        <section className='info' data-aos='zoom-out'>
          <img src={TeamWork} alt='Gambar' />
          <p>
            Website HayStyle didirikan pada awal februari 2022. Website HayStyle
            menyediakan berbagai macam kebutuhan fashion anda seperti kaos,
            celana, jaket dengan kualitas terbaik dan harga yang bersaing untuk
            anda. Prioritas kami adalah memberikan kenyamanan dan pelayanan
            maksimal untuk anda dalam berbelanja di toko kami. Adapun dalam
            melakukan transaksi menggunakan marketplace yaitu Tokopedia, Shopee,
            dan Lazada
          </p>
        </section>
        <section className='marketplace'>
          <h1 data-aos='fade-right'>Marketplace Kami</h1>
          <div className='content'>
            <a
              href={SOSMED.instagram}
              target='_blank'
              rel='noopener noreferrer'
            >
              <Marketplace title='Instagram' image={IcInstagram} />
            </a>

            <a href={SOSMED.facebook} target='_blank' rel='noopener noreferrer'>
              <Marketplace title='Facebook' image={IcFacebook} />
            </a>
            <a
              href={SOSMED.whatsApp}
              target={'_black'}
              rel='noopener noreferrer'
            >
              <Marketplace delay={900} title='WhattsApp' image={IcWhattsApp} />
            </a>
          </div>
        </section>
        <section className='marketplace'>
          <h1 data-aos='fade-right'>Sosial Media Kami</h1>
          <div className='content'>
            <a
              href={MARKETPLACE.tokopedia}
              target='_blank'
              rel='noopener noreferrer'
            >
              <Marketplace delay={500} title='Tokopedia' image={Tokopedia} />
            </a>
            <a
              href={MARKETPLACE.shopee}
              target='_blank'
              rel='noopener noreferrer'
            >
              <Marketplace delay={700} title='Shopee' image={Shopee} />
            </a>
            <a
              href={MARKETPLACE.lazada}
              target='_blank'
              rel='noopener noreferrer'
            >
              <Marketplace delay={900} title='Lazada' image={Lazada} />
            </a>
          </div>
        </section>
      </div>
    );
}

export default About